import { ENV } from "../../Utils";

export class ReviContentApi {
  baseApi = ENV.BASE_API;

  _rootBase() {
    // ENV.BASE_API puede venir como ".../api/v1" o ".../api/v1/revi"
    return String(this.baseApi || "")
      .replace(/\/revi\/?$/i, "")
      .replace(/\/$/, "");
  }

  _reviBase() {
    return `${this._rootBase()}/revi`;
  }

  async _fetchJson(url, params) {
    const response = await fetch(url, params);

    const text = await response.text();
    let json = {};
    try {
      json = text ? JSON.parse(text) : {};
    } catch {
      json = { raw: text };
    }

    if (!response.ok) {
      const msg = json?.message || json?.error || `HTTP ${response.status}`;
      const err = new Error(msg);
      err.status = response.status;
      err.payload = json;
      throw err;
    }
    return json;
  }

  // ===========================================================================
  // 1) LISTADOS
  // ===========================================================================

  async listScenes(accessToken, query = {}) {
    const url = new URL(`${this._reviBase()}/dashboard/scenes-v2`);

    Object.entries(query || {}).forEach(([k, v]) => {
      if (v === undefined || v === null || v === "") return;
      url.searchParams.set(k, String(v));
    });

    return this._fetchJson(url.toString(), {
      method: "GET",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
  }

  async listTherapyCategories(accessToken, { active = true } = {}) {
    const call = (url) =>
      this._fetchJson(url, {
        method: "GET",
        headers: { Authorization: `Bearer ${accessToken}` },
      });

    const primary = `${this._reviBase()}/therapy-category?active=${active}`;
    try {
      return await call(primary);
    } catch (e) {
      // ⚠️ Suprime log si es 404 en el primer intento
      if (e?.status === 404) {
        const fallback = `${this._rootBase()}/therapy-category?active=${active}`;
        console.info(
          "[ReviContentApi] /revi/therapy-category no existe, usando fallback estándar",
        );
        try {
          return await call(fallback);
        } catch (err) {
          // Si también falla, propaga
          throw err;
        }
      }
      throw e;
    }
  }

  // ===========================================================================
  // 2) ASSETS
  // ===========================================================================

  async uploadSceneBanner(
    accessToken,
    { idScene, title, description, isPublic, file },
  ) {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("idScene", idScene || "");
    formData.append("title", title || "Banner Revi");
    formData.append("description", description || "Subido desde Wizard");
    formData.append("isPublic", String(Boolean(isPublic)));

    return this._fetchJson(`${this._reviBase()}/upload/asset`, {
      method: "POST",
      headers: { Authorization: `Bearer ${accessToken}` },
      body: formData,
    });
  }

  // ✅ Alias para evitar roturas por refactors
  async uploadBanner(accessToken, payload) {
    return this.uploadSceneBanner(accessToken, payload);
  }

  async deleteBanner(accessToken, fileId) {
    if (!fileId) return;
    return this._fetchJson(`${this._rootBase()}/virtualscene/image/${fileId}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
  }

  // ===========================================================================
  // 3) ESCENAS (CREATE / READ / UPDATE / DELETE)
  // ===========================================================================

  async createReviSceneMinimal(accessToken, payload) {
    return this._fetchJson(`${this._reviBase()}/scenes`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(payload || {}),
    });
  }

  async deleteReviScene(accessToken, sceneId) {
    return this._fetchJson(`${this._reviBase()}/scenes/${sceneId}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
  }

  async getReviSceneById(accessToken, sceneId) {
    return this._fetchJson(`${this._reviBase()}/scenes/${sceneId}`, {
      method: "GET",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
  }

  async updateReviSceneMinimal(accessToken, sceneId, payload) {
    return this._fetchJson(`${this._reviBase()}/scenes/${sceneId}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(payload || {}),
    });
  }

  // ===========================================================================
  // 4) MODULE 07 (CLÍNICO)
  // ===========================================================================

  async createModule07(accessToken, sceneId, payload) {
    return this._fetchJson(`${this._reviBase()}/scenes/${sceneId}/module_07`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(payload || {}),
    });
  }

  async getModule07(accessToken, sceneId) {
    return this._fetchJson(`${this._reviBase()}/scenes/${sceneId}/module_07`, {
      method: "GET",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
  }

  async updateModule07(accessToken, sceneId, payload) {
    return this._fetchJson(`${this._reviBase()}/scenes/${sceneId}/module_07`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(payload || {}),
    });
  }
}
